import { render } from "./m-login.vue?vue&type=template&id=0c49041d&scoped=true&ts=true"
import script from "./m-login.vue?vue&type=script&lang=ts"
export * from "./m-login.vue?vue&type=script&lang=ts"

import "./m-login.vue?vue&type=style&index=0&id=0c49041d&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c49041d"]])

export default __exports__